<template>
    <div class="step-upload-component">
        <div class="row">
            <div class="col-xs-12">
                <job />
                <h2>Anlagen</h2>
                <div class="form-container">
                    <upload :file-list="formData.fileList" :additionalPost="{uuid: $store.state.uuid}" :options="{postUrl: '/bewerberformular/backend/upload.php', directUploadAfterPickingFiles: true}"  @uploaded="uploadChange" @remove="uploadChange" :error-message="errorMessage" />
                    <div class="row">
                        <div class="col-xs-12 col-md-6 col-md-push-6">
                            <button @click="submit" :disabled="loading" class="btn btn-green btn-big submit">{{ loading ? 'Wird versendet...' : 'Bewerbung absenden' }}</button>
                        </div>

                        <div class="col-xs-12 col-md-6 col-md-pull-8">
                            <div @click="$emit('back')" class="btn btn-transparent btn-big back"><i class="fa fa-chevron-left"></i> zurück</div>
                        </div>

                        <div class="col-xs-12">
                            <p class="notice">Mit * markierte Felder sind Pflichtfelder.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Upload from './upload';
import Job from './job';
import Utility from "../libs/Utility";

export default {
    inject: ['$validator'],
    data() {
        return {
            errorMessage: null,
            loading: false,
        }
    },
    computed: {
        formData() {
            return this.$store.state.stepUploadData;
        },
    },
    components: {
        Upload,
        Job,
    },
    methods: {
        submit() {
            this.$store.commit("setUploadData", this.formData);

            this.loading = true;
            this.errorMessage = null;
            if (!this.formData.fileList.length) {
                alert('Bitte laden Sie mindestens eine Datei hoch.');
                this.loading = false;
                return;
            }

            const exist = this.formData.fileList.some((file) => file.documentType === null || file.documentType === 'null')
            if (exist) {
                alert('Bitte geben Sie einen Dokumententyp an');
                this.loading = false;
                return;
            }

            const existLebenlauf = this.formData.fileList.some((file) => file.documentType === 'lebenslauf')
            if (!existLebenlauf) {
                alert('Bitte laden Sie einen Lebenslauf hoch oder wählen Sie den passenden Dokumententyp aus');
                this.loading = false;
                return;
            }

            if (!this.$store.state.job) {
                alert("Stellenbezeichnung fehlt");
                return;
            }
            Utility.post("/bewerberformular/backend/mail.php", {
                uuid: this.$store.state.uuid,
                job: this.$store.state.job,
                personalData: this.$store.state.stepPersonalData,
                contactData: this.$store.state.stepContactData,
                uploadData: this.$store.state.stepUploadData.fileList,
            })
                .then((response) => {
                    const result = JSON.parse(response);
                    if (result.success) {
                        this.$emit('submit');
                    } else {
                        alert(result.message);
                        this.loading = false;
                    }
                })
                .catch(() => {
                    alert("Ein unbekannter Fehler ist aufgetreten.");
                    this.loading = false;
                });
        },
        uploadChange(e) {
            this.errorMessage = null;
            this.$store.commit('setUploadData', {
                fileList: e.fileList,
            });
        },
    }
}
</script>
